import { fromJS } from 'immutable';
import ACTIONS from '../app.constants';
import {
    Inspection,
    InspectionReducerActionType,
    InspectionReducer,
    Comment,
    Violation,
    CommentList,
} from '../modules/application/types';

export default function inspectionReducer(
    state = fromJS({
        inspectionDetail: {},
        inspectionEditForm: {},
        InspectionComment: {},
    }),
    action: InspectionReducerActionType,
): InspectionReducer {
    switch (action.type) {
        case ACTIONS.GET_INSPECTION_DETAIL_BY_ID.PENDING: {
            return state.setIn(['inspectionDetail', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.GET_INSPECTION_DETAIL_BY_ID.SUCCESS: {
            return state
                .setIn(['inspectionDetail', 'loading'], false)
                .setIn(['inspectionDetail', 'data'], action.data.inspection)
                .setIn(['inspectionEditForm', 'data'], action.data.editForm);
        }
        case ACTIONS.GET_INSPECTION_DETAIL_BY_ID.ERROR: {
            return state.setIn(['inspectionDetail', 'loading'], false);
        }
        case ACTIONS.UPDATE_INSPECTION.PENDING: {
            return state.setIn(['inspectionData', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.UPDATE_INSPECTION.SUCCESS: {
            const inspectionData: Inspection = state.getIn(['inspectionDetail', 'data']);
            return state
                .setIn(['inspectionData', 'loading'], false)
                .setIn(['inspectionDetail', 'data'], inspectionData);
        }
        case ACTIONS.UPDATE_INSPECTION.ERROR: {
            return state.setIn(['inspectionData', 'loading'], false).setIn(['inspectionData', 'error'], action.error);
        }

        case ACTIONS.ADD_INSPECTION_COMMENT.PENDING: {
            return state.setIn(['inspectionComment', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.ADD_INSPECTION_COMMENT.SUCCESS: {
            const data = action.data;
            const inspectionComment: Comment[] = state.getIn(['inspectionComment', 'data']);
            const newCommentData = inspectionComment.concat(data);
            return state
                .setIn(['inspectionComment', 'loading'], false)
                .setIn(['inspectionComment', 'data'], newCommentData);
        }
        case ACTIONS.ADD_INSPECTION_COMMENT.ERROR: {
            return state
                .setIn(['inspectionComment', 'loading'], false)
                .setIn(['inspectionComment', 'error'], action.error);
        }

        case ACTIONS.INSPECTION_COMMENT_LIST.PENDING: {
            return state.setIn(['inspectionComment', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.INSPECTION_COMMENT_LIST.SUCCESS: {
            let loadedList: Comment[] = state.getIn(['inspectionComment', 'data']) ?? [];
            const inspectionCommentList: CommentList = action.data as CommentList;
            const loadMore = inspectionCommentList.length < action?.paginationData?.limit ? false : true;
            if (loadedList && action?.paginationData?.skip > 0) {
                loadedList = loadedList.concat(inspectionCommentList);
            } else {
                loadedList = inspectionCommentList;
            }
            const InspectionCommentsList = state
                .setIn(['inspectionComment', 'loadMore'], loadMore)
                .setIn(['inspectionComment', 'data'], loadedList);
            return InspectionCommentsList;
        }
        case ACTIONS.INSPECTION_COMMENT_LIST.ERROR: {
            return state.setIn(['inspectionComment', 'loading'], false);
        }

        case ACTIONS.GET_INSPECTION_VIOLATION_LIST.PENDING: {
            return state.setIn(['inspectionViolations', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.GET_INSPECTION_VIOLATION_LIST.SUCCESS: {
            let loadedList = state.getIn(['inspectionViolations', 'data']) ?? [];

            const violationList = action.data;

            const loadMore = violationList.length < action?.paginationData?.limit ? false : true;
            if (loadedList && action?.paginationData?.skip > 0) {
                loadedList = loadedList.concat(violationList);
            } else {
                loadedList = violationList;
            }
            return state
                .setIn(['inspectionViolations', 'loading'], false)
                .setIn(['inspectionViolations', 'loadMore'], loadMore)
                .setIn(['inspectionViolations', 'data'], loadedList);
        }
        case ACTIONS.GET_INSPECTION_VIOLATION_LIST.ERROR: {
            return state.setIn(['inspectionViolations', 'loading'], false);
        }

        case ACTIONS.ADD_INSPECTION_VIOLATION.PENDING: {
            return state.setIn(['inspectionViolations', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.ADD_INSPECTION_VIOLATION.SUCCESS: {
            const data: Violation[] = action.data;
            const violation: Violation[] = state.getIn(['inspectionViolations', 'data']);
            /*
              this is just adding latest violation 
              from data on top of violation list 
            */
            const reverseViolations: Violation[] = data.reverse();

            violation.unshift(...reverseViolations);

            return state
                .setIn(['inspectionViolations', 'loading'], false)
                .setIn(['inspectionViolations', 'data'], violation);
        }
        case ACTIONS.ADD_INSPECTION_VIOLATION.ERROR: {
            return state
                .setIn(['inspectionViolations', 'loading'], false)
                .setIn(['inspectionViolations', 'error'], action.error);
        }
        case ACTIONS.DELETE_INSPECTION_VIOLATION.PENDING: {
            return state.setIn(['inspectionViolations', 'loading'], action.status === 'LOADING' ? true : false);
        }

        case ACTIONS.DELETE_INSPECTION_VIOLATION.SUCCESS: {
            const violationId = action.payload.violationId;
            const violation = state.getIn(['inspectionViolations', 'data']);
            const filteredViolations = violation.filter((violation: Violation) => violation.id !== violationId);
            return state
                .setIn(['inspectionViolations', 'loading'], false)
                .setIn(['inspectionViolations', 'data'], filteredViolations);
        }
        case ACTIONS.DELETE_INSPECTION_VIOLATION.ERROR: {
            return state
                .setIn(['inspectionViolations', 'loading'], false)
                .setIn(['inspectionViolations', 'error'], action.error);
        }

        case ACTIONS.GET_ADD_INSPECTION_FORM_BY_ID.PENDING: {
            return state.setIn(['addInspectionForm', 'loading'], true);
        }
        case ACTIONS.GET_ADD_INSPECTION_FORM_BY_ID.SUCCESS: {
            return state
                .setIn(['addInspectionForm', 'loading'], false)
                .setIn(['addInspectionForm', 'data'], action.data);
        }
        case ACTIONS.GET_ADD_INSPECTION_FORM_BY_ID.ERROR: {
            return state.setIn(['addInspectionForm', 'loading'], false);
        }
        default: {
            return state;
        }
    }
}
